"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderChatBubbleShell = exports.withChatBubbleImage = exports.renderChatMessageFailedActions = exports.renderChatMessageTime = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const common_1 = require("@/components/common");
require("@/components/common");
const isChatBubbleImage = (src, typing) => !!src && !typing;
const renderChatMessageTime = (datetime) => {
    if (!datetime)
        return lit_1.nothing;
    return (0, lit_1.html) `
    <mm-text as="time" size="12">${datetime}</mm-text>
  `;
};
exports.renderChatMessageTime = renderChatMessageTime;
const renderChatMessageFailedActions = (failed, onRetry) => {
    if (!failed)
        return lit_1.nothing;
    return (0, lit_1.html) `
    <span class="failed-actions">
      <mm-text size="12" color="danger" role="alert">전송 실패</mm-text>
      <mm-icon-button
        size="small"
        variant="ghost"
        icon=${common_1.ICON_NAMES.RETRY}
        aria-label="재전송"
        @click=${onRetry}
      ></mm-icon-button>
    </span>
  `;
};
exports.renderChatMessageFailedActions = renderChatMessageFailedActions;
const renderChatBubbleImage = (src, typing) => {
    if (!isChatBubbleImage(src, typing))
        return lit_1.nothing;
    return (0, lit_1.html) `
    <mm-thumbnail src=${src} alt="" ratio="4:3"></mm-thumbnail>
  `;
};
/** ai/participant/my-chat-bubble이 공유하는 typing/src 상태와 image attribute 동기화. */
const withChatBubbleImage = (Base) => {
    class ChatBubbleImageElement extends Base {
        constructor() {
            super(...arguments);
            this.typing = false;
            this.src = '';
        }
        willUpdate() {
            this.toggleAttribute('image', isChatBubbleImage(this.src, this.typing));
        }
    }
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean })
    ], ChatBubbleImageElement.prototype, "typing", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], ChatBubbleImageElement.prototype, "src", void 0);
    return ChatBubbleImageElement;
};
exports.withChatBubbleImage = withChatBubbleImage;
/**
 * typing 인디케이터·이미지·메시지를 순서대로 조립하는 채팅 버블 셸.
 * 상태는 호스트가 이미 갖고 있으므로 호스트를 그대로 받고, 버블마다 다른 메시지 조각만 따로 받는다.
 * 인디케이터 색은 버블의 color를 그대로 물려받는다.
 */
const renderChatBubbleShell = (host, message) => (0, lit_1.html) `
  ${host.typing
    ? (0, lit_1.html) `
        <mm-typing-indicator></mm-typing-indicator>
      `
    : lit_1.nothing}
  ${renderChatBubbleImage(host.src, host.typing)} ${host.typing || host.src ? lit_1.nothing : message}
`;
exports.renderChatBubbleShell = renderChatBubbleShell;
//# sourceMappingURL=data:application/json;base64,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